import React, { useEffect, useState } from 'react';

import ToastService from '~/modules/services/toast-service';
import Modal from '~/modules/components/global/modal';
import Button from '~/modules/components/global/button';

const UpdateChecker = () => {

	const [currentVersion, setCurrentVersion] = useState(null);
	const [isModalDisplay, showModal] = useState(false);
	const [isToastDisplay, showToast] = useState(false);

	// Show 8 hours timer
	const remainingTimeString = '8:00:00';
	// const [remainingTimeString, setRemainingTimeString] = useState('8:00:00');

	useEffect(() => {
		const checkVersion = async() => {
			try {
				const response = await fetch('/version.txt', {
					cache: 'no-store'
				});
				const versionText = await response.text();

				// Get route path
				// const routeInfo = RouteService.getRouteInfo();
				// const avoidPageRefresh = ['work-request-queue', 'share-queue', 'ingest.view', 'share-edit', 'subtitler'].includes(routeInfo.name);

				if(
					currentVersion
					&& versionText !== currentVersion
					&& !isModalDisplay
					&& !isToastDisplay
				) {
					// If the user is on a page that can be refreshed, show a toast
					// if( !avoidPageRefresh || routeInfo.name === '' ) {

					// 	showModal(true);

					// 	// Show 8 hours timer
					// 	const remainingTime = 8 * 60 * 60;
					// 	let remainingSeconds = remainingTime;

					// 	const timerInterval = setInterval(() => {
					// 		remainingSeconds -= 1;
					// 		const hours = Math.floor(remainingSeconds / 3600);
					// 		const minutes = Math.floor((remainingSeconds % 3600) / 60);
					// 		const seconds = remainingSeconds % 60;

					// 		setRemainingTimeString(`${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
					// 	}, 1000);

					// 	return () => {
					// 		clearInterval(timerInterval);
					// 		setRemainingTimeString('8:00:00');
					// 		showModal(false);
					// 	};
					// }

					showToast(true);
					ToastService.createWithAction(
						'info',
								`🎉 A new version of the Platform is available`,
								'Refresh',
								() => {
									window.location.reload();
								},
								{
									dismissOnTimeout: false,
									autoClose: false,
									closeButton: false,
									closeOnClick: false
								}
					);

					return () => {
						showToast(false);
					};

				}

				setCurrentVersion(versionText);

			}
			catch(error) {
				console.error('Failed to fetch version.txt:', error);
			}
		};

		// Check version.txt occasionally on production only
		if( window.pixwel?.env !== 'development' ) {
			const versionCheckInterval = setInterval(checkVersion, 5000);
			return () => {
				clearInterval(versionCheckInterval);
			};
		}
	}, [currentVersion, isModalDisplay, isToastDisplay]);

	return (
		<Modal
			isOpen={isModalDisplay}
			title="New Version Available"
			content="🎉 A new version of the Platform is available. Would you like to reload the page ?"
			confirmText="Reload"
			cancelText="Later"
			onConfirm={() => {
				window.location.reload();
				showModal(false);
			}}
			onCancel={() => {
				showModal(false);
			}}
		>
			<Modal.Header style={{ marginBottom: 0, paddingTop: '3rem' }}>
				<h6 style={{ textAlign: 'center', paddingBottom: 0, paddingTop: 0 }}>
					New Version Available
				</h6>
			</Modal.Header>
			<Modal.Body style={{ marginTop: 15, paddingTop: 0, paddingBottom: 0 }}>
				<p style={{ marginBottom: 0, textAlign: 'center' }}>
					🎉 A new version of the Platform is available.
				</p>
			</Modal.Body>
			<Modal.Footer style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				paddingBottom: '3rem',
				marginTop: 20
			}}
			>
				<Button
					variant="secondary"
					data-testid={'admin-form-cancel-btn'}
					lighten
					onClick={() => {
						showModal(false);
						window.location.reload();
					}}
				>
					Refresh
				</Button>
				<p style={{ textAlign: 'center', marginTop: 5, fontSize: '0.8rem', color: 'gray' }}>
					Auto-reload in { remainingTimeString }
				</p>
			</Modal.Footer>
		</Modal>
	);
};

export default UpdateChecker;
